import styled from 'styled-components'
import { Flyout } from 'common-components'
import { COLORS } from 'consts/colors'

export { CrownBadgeIcon } from '../styled'

export const SubmenuFlyout = styled(Flyout)`
  box-shadow: 0px 4px 10px 0px #3866ff26;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 6px;
`

export const GroupItemWrapper = styled.div<{ $isActive: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  border: 1px solid transparent;
  background-color: ${({ $isActive }) =>
    $isActive ? COLORS.primaryLight : 'transparent'};

  &:hover {
    background-color: ${COLORS.primaryLight};
    border: 1px solid ${COLORS.borderColor};
  }
`

export const GroupItemHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const GroupItemTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const GroupChevron = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  transform: rotate(-90deg);
`

export const ProviderIconFallback = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: ${COLORS.secondarySemiDark};
  color: ${COLORS.white};
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`

export const SubmenuPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 340px;
  padding: 8px;
  border-radius: 6px;
  background-color: ${COLORS.white};
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: -5px;
    width: 5px;
    height: 64px;
  }
`

export const SubmenuVariantWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 8px;
  padding-right: 0;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryLight : 'transparent'};
  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? COLORS.borderColor : 'transparent')};

  &:hover {
    background-color: ${COLORS.primaryLight};
    border: 1px solid ${COLORS.borderColor};
  }
`

export const SubmenuVariantHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const SelectedCheck = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: 8px;
`

export const MobileSubmenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
`
